import React, { useEffect, useRef } from 'react';
import styles from './Drawer.module.scss';


const Drawer = ({
  open,
  onClose,
  placement = 'right',
  width = 378,
  height = 256,
  title,
  footer,
  closable = true,
  mask = true,
  maskClosable = true,
  children,
  className,
  style,
}) => {
  const drawerRef = useRef(null);

  // Close on ESC
  useEffect(() => {
    if (!open) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [open, onClose]);

  // Focus trap (basic)
  useEffect(() => {
    if (open && drawerRef.current) {
      drawerRef.current.focus();
    }
  }, [open]);

  const handleMaskClick = () => {
    if (maskClosable) onClose();
  };

  const drawerStyle = {
    ...style,
    width: placement === 'left' || placement === 'right' ? width : '100%',
    height: placement === 'top' || placement === 'bottom' ? height : '100%',
  };

  return (
    <>
      {mask && open && (
        <div
          className={styles.mask}
          onClick={handleMaskClick}
          aria-hidden="true"
        />
      )}
      <div
        className={[
          styles.drawer,
          styles[placement],
          open ? styles.open : '',
          className || '',
        ].join(' ')}
        style={drawerStyle}
        tabIndex={-1}
        ref={drawerRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? 'drawer-title' : undefined}
      >
        {(title || closable) && (
          <div className={styles.header}>
            {title && <div id="drawer-title" className={styles.title}>{title}</div>}
            {closable && (
              <button
                className={styles.close}
                aria-label="Close"
                onClick={onClose}
              >
                ×
              </button>
            )}
          </div>
        )}
        <div className={styles.body}>{children}</div>
        {footer && <div className={styles.footer}>{footer}</div>}
      </div>
    </>
  );
};

export default Drawer;

